import {css} from 'lit';
export const PikadayCustomizationStyles = css`
  /* TODO: Dark Mode left/right arrows are still black */

  .keli-dark .pika-prev,
  .keli-dark .pika-next {
    filter: invert(1);
  }
  
  .pika-single {
    font-family: inherit;
    background-color: var(--keli-background-color);
    color: var(--keli-text);
    border: 1px solid var(--keli-container-border);
  }

  .pika-single .pika-lendar {
    margin: 0;
  }

  .pika-single .pika-table th {
    color: var(--keli-text-subtle);
  }

  .pika-single .pika-label {
    background-color: inherit;
  }

  .pika-single .pika-button:hover {
    color: var(--keli-theme-white) !important;
    background-color: var(--keli-theme-accent-500) !important;
  }

  .pika-single .is-selected .pika-button {
    box-shadow: none;
    color: var(--keli-theme-white);
    background-color: var(--keli-theme-primary-500);
  }

  .pika-single .is-today .pika-button {
    color: var(--keli-text);
  }

  .pika-single .pika-button {
    background-color: var(--keli-subtle-background);
    color: var(--keli-text);
  }
`;